<template>
  <ion-content>
    <h1>Eingeloggt als {{ email }}</h1>
    <p><b>uid:</b> {{ uid }}</p>
    <p><b>idToken:</b> {{ idToken }}</p>
    <ion-button @click="logout">
      Ausloggen
    </ion-button>
  </ion-content>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'UserInfo',
  computed: {
    ...mapState(['email', 'uid', 'idToken']),
  },
  methods: mapActions(['logout']),
};
</script>
